export default {
	'navigation.global-shortcuts.sites': 'sites',
	'navigation.global-shortcuts.all-sites': 'All sites',
	'navigation.global-shortcuts.menu-link-item.disabled-item-aria-label': '(currently unavailable)',
};
